type LogLevel = "info" | "warn" | "error";

type DevLogger = {
    log: (...messages: unknown[]) => void;
    warn: (...messages: unknown[]) => void;
    error: (...messages: unknown[]) => void;
}

declare global {
    interface Console {
        dev: DevLogger;
    }
}

function sendToWebpack(level: LogLevel, messages: unknown[]): void {
    fetch("/__dev-log", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({level: level, messages: messages.map(String)})
    }).catch(() => {});
}

const devLogger: DevLogger = {
    log: (...messages: unknown[]): void => { if (DEV_MODE) sendToWebpack("info", messages); },
    warn: (...messages: unknown[]): void => { if (DEV_MODE) sendToWebpack("warn", messages); },
    error: (...messages: unknown[]): void => { if (DEV_MODE) sendToWebpack("error", messages); }
};

console.dev = devLogger;

export { devLogger };
